import React, { useMemo } from "react";
import { DollarCircleOutlined } from "@ant-design/icons";
import { Button, Modal, message } from "antd";
import { connect } from "dva";

const QuoteVehicle = props => {
  const { adminShipmentData, shipmentData, dispatch, isAdmin } = props;

  const dataShipment = useMemo(
    () => (isAdmin ? adminShipmentData : shipmentData),
    [isAdmin, shipmentData, adminShipmentData],
  );

  const request = isAdmin ? "adminShipmentView/sendPricesRequest" : "shipmentDetails/sendPricesRequest";

  const showRequestPricesConfirm = () => {
    Modal.confirm({
      title: "Request Price",
      content:
        "By clicking OK an Autosled admin will be notified of your quote request, once completed you will be receive a notification.",
      onOk() {
        const hide = message.loading("Requesting");

        dispatch({
          type: request,
          shipmentId: dataShipment.id,
        }).then(response => {
          hide();

          if (response.error) {
            message.error("Something went wrong while trying to request prices, please try again later.");
          } else {
            message.success("Request submitted successfully!");
          }
        });
      },
    });
  };

  return (
    <Button
      type="primary"
      style={{
        marginRight: 10,
      }}
      onClick={showRequestPricesConfirm}
      icon={<DollarCircleOutlined />}
    >
      Request Prices
    </Button>
  );
};

export default connect(({ shipmentDetails, adminShipmentView }) => ({
  shipmentData: shipmentDetails?.data,
  adminShipmentData: adminShipmentView?.data,
}))(QuoteVehicle);
